import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { BillingRecord } from 'src/models';
import {
  fetchBillingAction,
  fetchShortBillingAction,
} from 'src/services/billing';

const billingEntityAdapter = createEntityAdapter({
  selectId: (item: BillingRecord) => item.companyId,
});

export const billingSelectors = billingEntityAdapter.getSelectors();

const initialState: {
  isPending: boolean | null;
  hasError: boolean;
} = {
  isPending: null,
  hasError: false,
};

const billingSlice = createSlice({
  name: 'billing',
  initialState: billingEntityAdapter.getInitialState(initialState),
  reducers: {
    resetBillingState: (state) => {
      state.isPending = null;
      state.hasError = false;
      billingEntityAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBillingAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchBillingAction.fulfilled, (state, { payload }) => {
      billingEntityAdapter.setAll(state, payload);
      state.isPending = false;
    });
    builder.addCase(fetchShortBillingAction.fulfilled, (state, { payload }) => {
      billingEntityAdapter.setAll(state, payload);
      state.isPending = false;
    });
    builder.addCase(fetchBillingAction.rejected, (state) => {
      state.hasError = true;
    });
  },
});

const { reducer, actions } = billingSlice;

export const { resetBillingState } = actions;

export default reducer;
